import {useAppDispatch, useAppSelector} from "redux/hooks";

import PostionCatalog from "./subcomponents/PostionCatalog/PostionCatalog";
import type {TabsProps} from "antd";
import WorkingCatalog from "./subcomponents/WorkingCatalog/WorkingCatalog";
import TypeOfContract from "./subcomponents/TypeOfContract/TypeOfContract";
import WordAddress from "./subcomponents/WordAddress/WordAddress";
import WorkGroupCatalog from "./subcomponents/WorkGroupCatalog/WorkGroupCatalog";
import DepartmentCatalog from "./subcomponents/DepartmentCatalog/DepartmentCatalog";
import MonthSabbatical from "./subcomponents/MonthSabbatical/MonthSabbatical";
import {Divider, Form, Row, Select, Space, Tabs} from "antd";
import {tabKeys} from "types/enums";
import {
  setActiveTabAllocation,
} from "redux/reducer/employee";
import "./Catalog.scss";
import React, {useEffect} from "react";
const CatalogManage = () => {


  const activeTabAllocation = useAppSelector(
      state => state.employeesReducer.activeTabAllocation
  );
  const dispatch = useAppDispatch();

  const onChangeTabList = key => {
    dispatch(setActiveTabAllocation(key));
  };

  const items: TabsProps["items"] = [
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_POSITION,
      label: `Danh mục chức vụ `,
      children: <PostionCatalog />,
    },
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_DEPARTMENT,
      label: `Danh mục phòng ban  `,
      children: <DepartmentCatalog />,

    },
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_WORKING,
      label: `Danh mục số giờ làm việc/tuần  `,
      children: <WorkingCatalog />,

    },
    // {
    //   key: tabKeys.CATALOG_EMPLOYEE.TAB_WORK,
    //   label: `Danh mục nhóm công việc  `,
    //   children: <WorkGroupCatalog />,

    // },
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_CONTRACT,
      label: ` Danh mục loại hợp đồng  `,
      children: <TypeOfContract />,
    },
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_MONTH_SABBATICAL,
      label: `Cấu hình ngày nghỉ phép tháng  `,
      children: <MonthSabbatical/>,
    },
    {
      key: tabKeys.CATALOG_EMPLOYEE.TAB_WORK_ADDRESS,
      label: `Cấu hình địa chỉ làm việc  `,
      children: <WordAddress/>,
    },
  ];
  return (
      <div className="catalog-employee">
        <div className="container">
          <Tabs  onChange={onChangeTabList} activeKey={activeTabAllocation} items={items} />
        </div>
      </div>

  );

};

export default CatalogManage;
